import { render, staticRenderFns } from "./clockWrapper.vue?vue&type=template&id=63a9b17d&"
import script from "./clockWrapper.vue?vue&type=script&lang=js&"
export * from "./clockWrapper.vue?vue&type=script&lang=js&"
import style0 from "./clockWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports